export { default as paragraphElement } from './element';
export { default as paragraphPlugin } from './plugin';
